





















import { Component, Vue, Prop } from "vue-property-decorator";
import { l3draggable, l3droppable } from "@/directives/l3dragDrop";
// components
import MarkdownViewer from "../Shared/MarkdownViewer.vue";
import MarkdownEditor from "../Shared/MarkdownEditor.vue";
// interfaces
import { namespace } from "vuex-class";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";

const globals = namespace("globals");

@Component({
  components: { MarkdownViewer, MarkdownEditor },
  directives: { l3draggable, l3droppable }
})
export default class MarkdownElement extends Vue {
  @Prop() element!: CourseElementVm;
  @globals.Getter selectedExercise!: ExerciseVM;

  isBusy = false;
  showMarkdownEditor = false;

  get dropOptions() {
    return {
      accept: (data: any, ev?: DragEvent) => {
        // console.log("accept called: parsed:", data, "types:", ev?.dataTransfer?.types, "effectAllowed:", ev?.dataTransfer?.effectAllowed);
        if (!data) return false;
        if (data?.fileType && (data.fileType == "Markdown" || data.fileType == "Text")) return true;
        if (Array.isArray(data) && data[0] && data[0].name) return true;
        console.log("accept rejected");
        return false;
      },
      hoverClass: "drop-hover",
      transferTypes: ["Files"],
      targetGroups: ["markdown-file-details"],
      onDrop: (data: any) => {
        // console.log("Dropped data:", data);
        // Check for FileDetailsVm
        if (data?.fileType && (data.fileType == "Markdown" || data.fileType == "Text")) {
          this.element.text = data.aiSummary || "";
          this.element.contentUrl = data.filePath;
          return;
        }
        // Check for raw file array (dragged from OS / Browser). The file list is converted to array in the directive
        this.readTextFile(data?.[0]);
      }
    };
  }

  // Read a local markdown / text file into the element
  readTextFile(file: File | undefined) {
    if (file && file.name && (file.name.endsWith(".md") || file.name.endsWith(".txt"))) {
      // this.fileToUpload = file;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.element.text = e.target.result;
        this.element.aiSummary = this.element.text;
        this.element.contentUrl = null;
      };
      reader.readAsText(file);
    } else {
      this.$store.commit("ux/SB_FAILURE", {
        message: "Bei dieser Datei handelt es sich nicht um Text oder Markdown Datei.",
        timeout: 0
      });
    }
  }

  // open hidden file input
  openFileDialog() {
    const input = this.$refs.fileInput as HTMLInputElement | undefined;
    if (input) input.click();
  }

  onFileSelected(e: Event) {
    const input = e.target as HTMLInputElement;
    if (!input || !input.files || input.files.length === 0) return;
    const file = input.files[0];
    input.value = '';
    this.readTextFile(file);
  }

  openMarkdownEditor() {
    this.showMarkdownEditor = true;
  }
}
